module.exports = __webpack_public_path__ + "img/logo-white.dac25f8d.svg";